import get from 'lodash.get';
import ProductService from './ProductService';
import StandardService from './StandardService';
import envList from '../constants/envList';

class RtMaxService {
  static getProducts(source, preselect, isolationValue, env = envList.CA.path, worktype = '2') {
    switch (env) {
      case envList.CA.path: {
        let entreChevrons = ProductService.getEntreChevronsOptions(source);
        let sousChevrons = ProductService.getSousChevronsOptions(source);
        const suspentes = ProductService.getSuspentesOptions(source);
        const membrane = ProductService.getMembraneOptions(source);
        const adhesifs = ProductService.getAdhesifOptions(source);
        const mastics = ProductService.getMasticOptions(source);

        // create copie off all object, because they have the same reference
        entreChevrons = entreChevrons.map((entreChevron) => {
          return JSON.parse(JSON.stringify(entreChevron));
        });

        // create copie off all object, because they have the same reference
        sousChevrons = sousChevrons.map((sousChevron) => {
          return JSON.parse(JSON.stringify(sousChevron))
        });

        const adhesifPrice = adhesifs[3].value.price;
        const masticPrice = mastics[0].value.price;

        const sousChevronsRtmax = sousChevrons.filter(
          x => x.value.workstype.indexOf('2') > -1
        );

        const suspentesRtmax = suspentes.filter(
          x => x.value.workstype.indexOf('2') > -1
        );

        const membraneRtmax = membrane.filter(
          x => x.value.workstype.indexOf('2') > -1
        );

        const entreChevronsItemId = get(
          preselect.find(
            i => (i.solution_id === 2 && i.entreousouschevron === 1)
          ),
          'product_id',
          null
        );

        const sousChevronItemId = get(
          preselect.find(
            i => (i.solution_id === 2 && i.entreousouschevron === 2)
          ),
          'product_id',
          null
        );

        const suspentesId = get(
          preselect.find(
            i => (i.solution_id === 2 && i.type_id === 5)
          ),
          'product_id',
          null,
        );

        const adhesifItemId = get(
          preselect.find(
            i => (i.solution_id === 2 && i.type_id === 5)
            && adhesifs.find(
              adhesif => adhesif.key === i.product_id
            )
          ),
          'product_id',
          null
        );

        const membranesItemRtmax = membraneRtmax.find(({ key }) => key === 93)
          .value;
        membranesItemRtmax.membraneRouleaux = Math.ceil(
          (isolationValue * 1.3) / 75
        );
        const membranePriceRtmax = membraneRtmax.find(({ key }) => key === 93)
          .value.price;

        const entreChevronsItem = Object.assign(
          {},
          get(
            entreChevrons.find(
              productOption => productOption.key === entreChevronsItemId
            ),
            'value',
            null
          )
        );

        const sousChevronsItem = Object.assign(
          {},
          get(
            sousChevrons.find(
              productOption => productOption.key === sousChevronItemId
            ),
            'value',
            null,
          )
        );

        const found = suspentesRtmax.find(
          suspente => suspente.key === suspentesId
        );

        let suspentesItem;
        if (found) suspentesItem = found.value;

        const selectedAdhesif = get(
          adhesifs.find(
            adhesif => adhesif.key == adhesifItemId
          ),
          'value',
          {
            m2perpiece: 1.6,
            pieceperpackage: 40,
            price: 26.13,
          }
        );

        return {
          adhesifPrice,
          adhesifs,
          entreChevrons,
          entreChevronsItem,
          masticPrice,
          mastics,
          membrane,
          membranePriceRtmax,
          membraneRtmax,
          membranesItemRtmax,
          selectedAdhesif,
          sousChevrons,
          sousChevronsItem,
          sousChevronsRtmax,
          suspentes,
          suspentesItem,
          suspentesRtmax,
        };
      }
      case envList.IME.path: {
        const insulators = ProductService.getInsulatorOptions(source);
        const supports = ProductService.getSupportOptions(source);
        const pastilles = ProductService.getPastilleOptions(source);
        const adhesifsIME = ProductService.getAdhesifOptions(source);
        const masticsIME = ProductService.getMasticOptions(source);

        let membranes = [];
        if (worktype === '2') membranes = ProductService.getMembraneOptions(source);

        const selectedInsulator = get(insulators.find(
          insulator => (insulator.value.workstype.includes(worktype)
            && preselect.find(
              pre => pre.product_id === insulator.key
              && pre.solution_id === Number(worktype) + 3 // the solution id for the wall start at 3 and is ordered like the korkType
            ))
        ), 'value', null);

        const selectedSupport = get(supports.find(
          support => (support.value.workstype.includes(worktype)
            && preselect.find(
              pre => pre.product_id === support.key
              && pre.solution_id === Number(worktype) + 3 // the solution id for the wall start at 3 and is ordered like the korkType
            ))
        ), 'value', null);

        let selectedMembrane = {};
        if (worktype === '2') {
          selectedMembrane = get(membranes.find(
            membraneIME => (membraneIME.value.workstype.includes(worktype)
          && preselect.find(
            pre => pre.product_id === membraneIME.key
            && pre.solution_id === Number(worktype) + 3 // the solution id for the wall start at 3 and is ordered like the korkType
          )
            )
          ), 'value', null);
        }

        const selectedPastille = get(pastilles.find(
          pastille => (pastille.value.workstype.includes(worktype)
          && preselect.find(
            pre => pre.product_id === pastille.key
            && pre.solution_id === Number(worktype) + 3 // the solution id for the wall start at 3 and is ordered like the korkType
          )
          )
        ), 'value', null);

        const selectedAdhesif = get(adhesifsIME.find(
          adhesif => (adhesif.value.workstype.includes(worktype)
          && preselect.find(
            pre => pre.product_id === adhesif.key
            && pre.solution_id === Number(worktype) + 3 // the solution id for the wall start at 3 and is ordered like the korkType
          )
          )
        ), 'value', null);

        const selectedMastic = get(masticsIME.find(
          mastic => (mastic.value.workstype.includes(worktype)
          && preselect.find(
            pre => pre.product_id === mastic.key
            && pre.solution_id === Number(worktype) + 3 // the solution id for the wall start at 3 and is ordered like the korkType
          )
          )
        ), 'value', null);

        return {
          adhesifs: adhesifsIME,
          insulators,
          mastics: masticsIME,
          membranes,
          pastilles,
          selectedAdhesif,
          selectedInsulator,
          selectedMastic,
          selectedMembrane,
          selectedPastille,
          selectedSupport,
          supports,
        };
      }
      case envList.CP.path: {
        const insulators = ProductService.getInsulatorOptions(source);
        const insulatorsSecond = ProductService.getInsulatorSecond(source);
        const adhesives = ProductService.getAdhesifOptions(source);
        const membranes = ProductService.getMembraneOptions(source);
        const mastics = ProductService.getMasticOptions(source);
        const selectedInsulator = get(
          insulators.find(
            insulator => (
              insulator.value.workstype.includes('2')
              && preselect.find(
                pre => pre.product_id === insulator.key && pre.solution_id === 9
              )
            )
          ),
          'value',
          null,
        );
        const selectedInsulatorSecond = get(
          insulatorsSecond.find(
            insulator => (
              insulator.value.workstype.includes('2')
              && preselect.find(
                pre => pre.product_id === insulator.key && pre.solution_id === 9
              )
            )
          ),
          'value',
          null,
        );

        const selectedMembrane = get(
          membranes.find(
            membrane => (
              membrane.value.workstype.includes('2')
              && preselect.find(
                pre => pre.product_id === membrane.key && pre.solution_id === 9
              )
            )
          ),
          'value',
          null,
        );

        const selectedAdhesive = get(
          adhesives.find(
            adhesive => (
              adhesive.value.workstype.includes('2')
              && preselect.find(
                pre => pre.product_id === adhesive.key && pre.solution_id === 9
              )
            )
          ),
          'value',
          null,
        );

        const selectedMastic = get(
          mastics.find(
            mastic => (
              mastic.value.workstype.includes('2')
              && preselect.find(
                pre => pre.product_id === mastic.key && pre.solution_id === 9
              )
            )
          ),
          'value',
          null,
        );

        return {
          insulators,
          insulatorsSecond,
          adhesives,
          membranes,
          selectedInsulator,
          selectedInsulatorSecond,
          selectedMembrane,
          selectedAdhesive,
          selectedMastic,
        };
      }
      default:
        return {};
    }
  }


  static calculateCost(products, isolationValue, env = envList.CA.path) {
    return StandardService.calculateCost(products, isolationValue, env);
  }
}

export default RtMaxService;



// WEBPACK FOOTER //
// ./src/services/rtMaxService.js